module.exports = {
    trackEvent: function(category, action, label) {
        //SILENCE IS GOLDEN
    }
};